export const CORRELATIONS = ['AND', 'OR'];